import { render, staticRenderFns } from "./BuildingReport.vue?vue&type=template&id=281d7c4c&"
import script from "./BuildingReport.vue?vue&type=script&lang=js&"
export * from "./BuildingReport.vue?vue&type=script&lang=js&"
import style0 from "./BuildingReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../BuildingCatalog/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports